export default __webpack_public_path__ + "static/media/idealProtectSpecial.9cb1c3c8.jpg";